export default __webpack_public_path__ + "static/OrangeCounty-f544ba8575e1de3158a94209397e2f8c.png";